import React from 'react';
import { Button, } from 'reactstrap';

export default function IpRestrictedNotice(props) {
  const { company, ipGrant: { status, ip, }, } = props;

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div className="card">
            <div className="card-body text-center">
              <h5 className="mb-3">
                <span className="fas fa-network-wired mr-1" />
                IPアドレス制限
              </h5>
              {
                status === 'denied' ? (
                  <>
                    <p>{company.display_name} ではIPアドレス制限が設定されており、現在のIPアドレスからはアクセスできません。</p>
                    {ip && <p className="text-muted small">現在のIPアドレス: {ip}</p>}
                  </>
                ) : (
                  <>
                    <p>アクセス可否の確認に失敗しました。</p>
                    <Button color="primary" onClick={() => window.location.reload()}>再読み込み</Button>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
